export default "__VITE_ASSET__Yighq3uE__";